var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewsletterIcon1 = function SvgNewsletterIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 56,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 0.336,
    fill: "#B8EBE7",
    fillOpacity: 0.2,
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newsletter-icon-1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.836 41.25v-9.5h-5v9.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF0F7",
    d: "M40.086 32c.825 0 1.5-.675 1.5-1.5v-6c0-1.375-1.125-2.5-2.5-2.5h-4a2.507 2.507 0 0 0-2.5 2.5V32c.825 0 1.5.675 1.5 1.5V43h6V32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#403F3F",
    d: "M20.086 41.25a.737.737 0 0 1-.75-.75v-3h-3.5v3c0 .425-.325.75-.75.75a.737.737 0 0 1-.75-.75v-3.75c0-.425.325-.75.75-.75h5c.425 0 .75.325.75.75v3.75c0 .425-.325.75-.75.75ZM28.836 41.25a.737.737 0 0 1-.75-.75v-8h-3.5v8c0 .425-.325.75-.75.75a.737.737 0 0 1-.75-.75v-8.75c0-.425.325-.75.75-.75h5c.425 0 .75.325.75.75v8.75c0 .425-.325.75-.75.75ZM40.086 43.75a.737.737 0 0 1-.75-.75V32c0-.425.325-.75.75-.75s.75-.325.75-.75v-6a1.74 1.74 0 0 0-1.75-1.75h-4a1.74 1.74 0 0 0-1.75 1.75V32c0 .425-.325.75-.75.75a.737.737 0 0 1-.75-.75v-7.5c0-1.8 1.45-3.25 3.25-3.25h4c1.8 0 3.25 1.45 3.25 3.25v6c0 .975-.625 1.8-1.5 2.125V43c0 .425-.325.75-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#403F3F",
    d: "M37.086 43.75a.737.737 0 0 1-.75-.75v-9.5c0-.425.325-.75.75-.75s.75.325.75.75V43c0 .425-.325.75-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.086 19.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#403F3F",
    d: "M37.086 20.25c-1.8 0-3.25-1.45-3.25-3.25s1.45-3.25 3.25-3.25 3.25 1.45 3.25 3.25-1.45 3.25-3.25 3.25Zm0-5a1.74 1.74 0 0 0-1.75 1.75c0 .975.775 1.75 1.75 1.75a1.74 1.74 0 0 0 1.75-1.75 1.74 1.74 0 0 0-1.75-1.75ZM34.086 43.75a.737.737 0 0 1-.75-.75v-9.5c0-.425.325-.75.75-.75s.75.325.75.75V43c0 .425-.325.75-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#403F3F",
    d: "M43.336 43.75h-30a.737.737 0 0 1-.75-.75c0-.425.325-.75.75-.75h30c.425 0 .75.325.75.75s-.325.75-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4ECDC4",
    d: "M13.334 33.75a.788.788 0 0 1-.675-.4.72.72 0 0 1 .325-1c8.05-4.125 14.15-11.075 17.15-19.6.15-.4.575-.6.95-.45.4.125.6.575.45.95-3.125 8.875-9.475 16.15-17.85 20.425a.882.882 0 0 1-.35.075Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newsletter-icon-1_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.336 12h32v32h-32z"
  })))));
};
export default SvgNewsletterIcon1;